<template>
    <div class="tc-question">
        <title-section
            :title="title"
            :text="description"
        />

        <p
            v-if="note"
            class="note"
            v-html="note">
        </p>

        <money-slider
            v-if="( this.type == 'money' )"
            v-bind="sliderProps"
            v-on:sliderChange="sliderValue = $event"
            v-on:customChange="customValue = $event">
        </money-slider>

        <number-slider
            v-if="( this.type == 'number' )"
            v-bind="sliderProps"
            v-on:sliderChange="sliderValue = $event"
            v-on:customChange="customValue = $event">
        </number-slider>

        <time-slider
            v-if="( this.type == 'time' )"
            class="Slider"
            v-bind="sliderProps"
            v-on:sliderChange="sliderValue = $event"
            v-on:customChange="customValue = $event">
        </time-slider>
    </div>
</template>

<script>
    import MoneySlider from '../sliders/MoneySlider.vue';
    import TimeSlider from '../sliders/TimeSlider.vue';
    import NumberSlider from '../sliders/NumberSlider.vue';
    import TitleSection from '../TitleSection.vue';
    import * as track from '@/utilities/tracking';
    export default {
        name: 'SliderQuestion',
        components: {
            MoneySlider,
            TimeSlider,
            NumberSlider,
            TitleSection
        },
        created: function() {
            this.$store.commit('update', { name: 'previous', value: this.previous });
        },
        mounted() {
            track.step(this.$store.state.step);
        },
        props: {
            title: String,
            description: String,
            type: String,
            note: {
                type: String,
                default: null
            },
            next: [String, Number],
            format: String,
            min: Number,
            previous: [String, Number],
            max: Number,
            tick: Number,
            step: Number,
            value: [Number, String, Boolean],
            customVal: [Number, String, Boolean],
            name: String,
            customName: String
        },
        computed: {
            sliderProps: function () {
                return {
                    min:this.min,
                    max:this.max,
                    tick:this.tick,
                    step:this.step,
                    format:this.format,
                    sliderValue: this.sliderValue,
                    useCustom: this.useCustom,
                    isButtonDisabled: this.isButtonDisabled,
                    customValue: this.customValue,
                    next:this.next,
                    ariaLabel: `${this.title}, ${this.description}`,
                }
            },
            isButtonDisabled: function() {
                if (this.customVal >= this.max) {
                    return false
                } else {
                    return true;
                }
            },
            sliderValue: {
                get: function() {
                    if (this.value === false) {
                        return this.max;
                    } else if (this.value <= this.max) {
                        return this.value;
                    } else {
                        return this.max;
                    }
                },
                set: function(value) {
                    if (value === this.max) {
                        this.$store.commit('update', { name: this.name, value: false });
                        return value;
                    } else {
                        this.$store.commit('update', { name: this.name, value });
                    }
                }
            },
            customValue: {
                get: function() {
                    if (this.customVal > 0) {
                        if (this.type == 'money') {
                            return '$ ' + (this.customVal).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        } else if (this.type == 'time') {
                            return (this.customVal) + ' years';
                        } else {
                            return this.customVal;
                        }

                    } else {
                        return '';
                    }
                },
                set: function(value) {
                    this.$store.commit('update', { name: this.customName, value: parseInt(value.replace(/\D/g,'')) });
                }
            },
            useCustom: function() {
                return (this.value === false ? true : false);
            }
        }
    }
</script>
